import { sessionPrefix } from "./helpers";

export const ticketsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/tickets`;
export const newTicketPath = (session: LightSessionInterface, ticket: TicketRef) =>
  `${sessionPrefix(session)}/tickets/new/${ticket.id}`;
export const showTicketPath = (session: LightSessionInterface, ticket: TicketRef) =>
  `${sessionPrefix(session)}/tickets/${ticket.id}`;
export const showTicketPathById = (session: LightSessionInterface, ticketId: string) =>
  `${sessionPrefix(session)}/tickets/${ticketId}`;
